import { render, staticRenderFns } from "./showGongShiDialog.vue?vue&type=template&id=95937dd6&scoped=true&"
import script from "./showGongShiDialog.vue?vue&type=script&lang=js&"
export * from "./showGongShiDialog.vue?vue&type=script&lang=js&"
import style0 from "./showGongShiDialog.vue?vue&type=style&index=0&id=95937dd6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95937dd6",
  null
  
)

export default component.exports